import { render, staticRenderFns } from "./epmsa050.vue?vue&type=template&id=50e070e3&scoped=true"
import script from "./epmsa050.vue?vue&type=script&lang=js"
export * from "./epmsa050.vue?vue&type=script&lang=js"
import style0 from "./epmsa050.vue?vue&type=style&index=0&id=50e070e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e070e3",
  null
  
)

export default component.exports